/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceLocation } from './ServiceLocation';
import {
    ServiceLocationFromJSON,
    ServiceLocationFromJSONTyped,
    ServiceLocationToJSON,
} from './ServiceLocation';

/**
 * 
 * @export
 * @interface Demographics
 */
export interface Demographics {
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    gender: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    date_of_birth: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    race?: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    marital_status?: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    primary_spoken_language?: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    religion?: string;
    /**
     * 
     * @type {string}
     * @memberof Demographics
     */
    living_arrangement?: string;
    /**
     * 
     * @type {ServiceLocation}
     * @memberof Demographics
     */
    service_location: ServiceLocation;
}

/**
 * Check if a given object implements the Demographics interface.
 */
export function instanceOfDemographics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "gender" in value;
    isInstance = isInstance && "date_of_birth" in value;
    isInstance = isInstance && "service_location" in value;

    return isInstance;
}

export function DemographicsFromJSON(json: any): Demographics {
    return DemographicsFromJSONTyped(json, false);
}

export function DemographicsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Demographics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gender': json['gender'],
        'date_of_birth': json['date_of_birth'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'race': !exists(json, 'race') ? undefined : json['race'],
        'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
        'marital_status': !exists(json, 'marital_status') ? undefined : json['marital_status'],
        'primary_spoken_language': !exists(json, 'primary_spoken_language') ? undefined : json['primary_spoken_language'],
        'religion': !exists(json, 'religion') ? undefined : json['religion'],
        'living_arrangement': !exists(json, 'living_arrangement') ? undefined : json['living_arrangement'],
        'service_location': ServiceLocationFromJSON(json['service_location']),
    };
}

export function DemographicsToJSON(value?: Demographics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gender': value.gender,
        'date_of_birth': value.date_of_birth,
        'ssn': value.ssn,
        'race': value.race,
        'nickname': value.nickname,
        'marital_status': value.marital_status,
        'primary_spoken_language': value.primary_spoken_language,
        'religion': value.religion,
        'living_arrangement': value.living_arrangement,
        'service_location': ServiceLocationToJSON(value.service_location),
    };
}

